import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'

const studentLinks = [
  { to: '/student', label: 'Overview', icon: 'fa-house', end: true },
  { to: '/student/courses', label: 'My Courses', icon: 'fa-book-bookmark' },
  { to: '/student/attendance', label: 'Attendance', icon: 'fa-user-check' },
  { to: '/student/materials', label: 'Materials', icon: 'fa-folder-open' },
  { to: '/student/assignments', label: 'Assignments', icon: 'fa-pen-nib' },
]

export function StudentLayout() {
  const { user, logout } = useAuth()
  const initials = (user?.first_name || user?.username || 'ST').slice(0, 2).toUpperCase()

  return (
    <div className="flex h-full overflow-hidden">
      <aside className="flex w-64 flex-col justify-between overflow-y-auto bg-slate-900 text-slate-300">
        <div>
          <div className="flex items-center gap-3 border-b border-slate-800 p-5">
            <div className="rounded-lg bg-student-600 p-2 text-white">
              <i className="fa-solid fa-graduation-cap text-xl" />
            </div>
            <div>
              <h1 className="text-lg leading-tight font-bold text-white">Academic Portal</h1>
              <span className="text-student-500 text-xs font-medium tracking-wider uppercase">
                Student
              </span>
            </div>
          </div>
          <nav className="space-y-1 p-4 text-sm">
            {studentLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-lg px-3 py-2.5 ${
                    isActive
                      ? 'bg-student-600 font-medium text-white'
                      : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                  }`
                }
              >
                <i className={`fa-solid ${link.icon} w-5`} />
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="flex items-center justify-between border-t border-slate-800 p-4">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-700 font-bold text-white">
              {initials}
            </div>
            <div>
              <p className="text-sm font-medium text-white">
                {user?.first_name || user?.username}
              </p>
              <p className="text-xs text-slate-500">Student</p>
            </div>
          </div>
          <button
            type="button"
            onClick={logout}
            className="text-slate-400 hover:text-red-400"
            title="Logout"
          >
            <i className="fa-solid fa-right-from-bracket" />
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto bg-slate-50">
        <Outlet />
      </main>
    </div>
  )
}
